import { Observable, of } from 'rxjs';
import { IAccountDisabledService } from '../account-services';

export class AccountDisabledServiceMock implements IAccountDisabledService {
  getRouteParent(): string {
    return '/account-disabled';
  }

  gotoDeactivatedAccountRoutes(): boolean {
    return true;
  }

  finishAccountReactivationWithoutRedirection(): Observable<unknown> {
    return of(null);
  }

  finishTermsDeclineWithoutRedirection(): Observable<unknown> {
    return of(null);
  }

  finishTermsAcceptanceWithoutRedirection(): Observable<unknown> {
    return of(null);
  }

  showCancelButtonsOnDeactivatedAccount(): boolean {
    return true;
  }
}
